var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowdBk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09443 10.4136L1.67725 4.58025L2.9897 3.58643L6.75065 8.55315L10.5116 3.58643L11.8241 4.58025L7.40688 10.4136C7.25128 10.6191 7.0084 10.7398 6.75065 10.7398C6.4929 10.7398 6.25003 10.6191 6.09443 10.4136Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowdBk);
export default __webpack_public_path__ + "static/media/icon_arrowd_bk.086e2326bc609e2a247a06f833baa0c5.svg";
export { ForwardRef as ReactComponent };